import React, { useMemo } from 'react';
import './FormPageProgress.scss';

export interface FormPagesLayoutProgressProps {
  currentProgress: number;
  maximumProgress: number;
}

export function FormPageProgress({ currentProgress, maximumProgress }: FormPagesLayoutProgressProps) {
  const progress = useMemo<boolean[]>(
    () => [...Array(currentProgress).fill(true)].concat([...Array(maximumProgress - currentProgress).fill(false)]),
    [currentProgress, maximumProgress],
  );

  return (
    <div className='form-page-progress'>
      {progress.map((filled, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index} className={`form-pages-layout-progress-bar ${filled ? 'filled' : 'empty'}`} />
      ))}
    </div>
  );
}
